import { useCallback, useEffect, useState, useRef } from 'react';
import styles from './ServiceSections.module.css';
import { JLLServices } from '../data/JLLServices.js';
import ServiceSection from './ServiceSection.js';


function ServiceSections() {

    const jllServiceItems = [];

    Object.keys(JLLServices).forEach((key, index) => {
        jllServiceItems.push(
            <ServiceSection  serviceSection={JLLServices[key]} />
        )
    })


    return (
        <div id="services" className={styles.serviceSections}>
            {jllServiceItems ? jllServiceItems : null}
        </div>

    );
}

export default ServiceSections;
